import * as ContextMenu from '@studio/design-system/context-menu';
import { getMenuItemHandler } from '@studio/design-system/menu';
import { shortCircuit } from '@studio/react-utils/event';
import { useLatestFn } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import type { MenuProps } from './types.js';
import { Sel, STagNew } from '#~/stag/index.js';

/** `<Menu>` component. */
export const Menu = ({ handler, isDeletable, ...props }: MenuProps): ReactElement => {
  const handleSelect = useLatestFn((event: Event) => {
    getMenuItemHandler(handler, event)?.();
  });

  return (
    <ContextMenu.Content onCloseAutoFocus={shortCircuit} {...props}>
      <ContextMenu.Item
        action='add'
        icon='settings'
        label='Add preset group'
        onSelect={handleSelect}
      />

      <ContextMenu.Item
        // Per playwright-stag-selectors-only (ai.knowledge/platform): drive the real menu action.
        {...STagNew(Sel.MainRoomBottomTrayPresets, 'group.rename')}
        action='rename'
        icon='edit'
        label='Rename group'
        onSelect={handleSelect}
      />

      <ContextMenu.Item
        action='remove'
        // Per context-menu-item-stag-pattern (ai.knowledge/platform/studio.client): data-action dispatch remains separate from the test selector.
        {...STagNew(Sel.MainRoomBottomTrayPresets, 'group.remove')}
        disabled={!isDeletable}
        icon='trash'
        label='Delete group'
        onSelect={handleSelect}
      />
    </ContextMenu.Content>
  );
};
